export default "__VITE_ASSET__CEAzfy$o__"